import { render, staticRenderFns } from "./route-map.vue?vue&type=template&id=035271f5&"
import script from "./route-map.vue?vue&type=script&lang=ts&"
export * from "./route-map.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports